import type { FC } from "react";

import { useTranslation } from "src/translations";
import { Link } from "./Link";

export type PaginationProps = Readonly<{
    pagination?: {
        page?: number;
        pageSize?: number;
        pageCount?: number;
        total?: number;
    };
    url: (page: number) => string;
}>;

export const Pagination: FC<PaginationProps> = ({ pagination, url }: PaginationProps) => {
    const { t } = useTranslation();

    if (!pagination) return null;

    const { page = 1, pageCount = 1 } = pagination;
    const hasPrevious = page > 1;
    const hasNext = pageCount > page;

    return (
        <div className="flex items-center justify-center">
            <div className="mr-8">
                <Link href={url(page - 1)} className={`text-nowrap ${hasPrevious ? "visible" : "invisible"}`}>
                    ← {t("common.previous")}
                </Link>
            </div>
            <div className="text-nowrap text-sm text-secondary">{t("common.pageInfo", { page, pageCount })}</div>
            <div className="ml-8">
                <Link href={url(page + 1)} className={`text-nowrap ${hasNext ? "visible" : "invisible"}`}>
                    {t("common.next")} →
                </Link>
            </div>
        </div>
    );
};
